import './TrackCard.css'

function TrackCard({ track, onAnalyze, showCompatibility = false, compatibility = null, analysis = null }) {
  const formatDuration = (ms) => {
    const seconds = Math.floor(ms / 1000)
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  const placeholderImage = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect width="200" height="200" fill="%23333"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="%23666" font-size="16"%3ENo Image%3C/text%3E%3C/svg%3E'

  return (
    <div className="track-card">
      <div className="track-artwork">
        <img
          src={track.artwork_url || placeholderImage}
          alt={track.title}
          onError={(e) => {
            e.target.src = placeholderImage
          }}
        />
        {showCompatibility && compatibility && (
          <div className="compatibility-badge">
            {compatibility}% Match
          </div>
        )}
      </div>

      <div className="track-info">
        <h4 className="track-title">{track.title}</h4>
        <p className="track-artist">{track.user?.username || track.artist}</p>

        <div className="track-meta">
          {track.genre && (
            <span className="meta-tag">{track.genre}</span>
          )}
          {track.duration && (
            <span className="meta-duration">{formatDuration(track.duration)}</span>
          )}
        </div>

        {analysis && (
          <div className="track-stats">
            <span className="stat">
              <strong>BPM:</strong> {analysis.bpm}
            </span>
            {analysis.key && (
              <span className="stat">
                <strong>Key:</strong> {analysis.key}
              </span>
            )}
            {analysis.energy !== undefined && (
              <span className="stat">
                <strong>Energy:</strong> {(analysis.energy * 100).toFixed(0)}%
              </span>
            )}
          </div>
        )}
      </div>

      <div className="track-actions">
        <button
          className="btn-primary"
          onClick={() => onAnalyze(track)}
        >
          {showCompatibility ? 'Preview Blend' : 'Analyze & Find Blends'}
        </button>
      </div>
    </div>
  )
}

export default TrackCard
